import React, { createContext, useContext, useState, useCallback } from 'react';

const InsightChatContext = createContext();

export function InsightChatProvider({ children }) {
  const [messages, setMessages] = useState([]);
  const [thoughtProcess, setThoughtProcess] = useState([]);
  const [title, setTitle] = useState({ value: '' });

  const addThoughtProcess = (newThought) => {
    setThoughtProcess((prevThoughts) => {
      const updatedThoughts = [...prevThoughts, newThought];
      updatedThoughts.sort((a, b) => a.timestamp - b.timestamp);
      return updatedThoughts;
    });
  };

  const removeThoughtProcess = (lastMsgId) => {
    setThoughtProcess((prevThoughts) => {
      const newTP = prevThoughts.filter((elem) => {
        if (elem.messageId === lastMsgId) return false;
        else return true;
      });
      return newTP;
    });
  };

  const removeEntireThoughtProcess = () => {
    setThoughtProcess([]);
  };

  return (
    <InsightChatContext.Provider
      value={{
        messages,
        setMessages,
        title,
        setTitle,
        thoughtProcess,
        setThoughtProcess,
        addThoughtProcess,
        removeThoughtProcess,
        removeEntireThoughtProcess,
      }}
    >
      {children}
    </InsightChatContext.Provider>
  );
}

export function useInsightChatContext() {
  return useContext(InsightChatContext);
}
